import { createAction, props } from '@ngrx/store';

import { Policy } from '@lockton-apps/shared/interfaces';

import { AuthContactActionTypes } from './actions.model';

// Load All As Contact
export const loadAllPolicies = createAction(
  AuthContactActionTypes.LoadAllPolicies
);

export const loadAllPoliciesSuccess = createAction(
  AuthContactActionTypes.LoadAllPoliciesSuccess,
  props<{ policies: Policy[] }>()
);

export const loadAllPoliciesFailure = createAction(
  AuthContactActionTypes.LoadAllPoliciesFailure,
  props<{ error: unknown }>()
);
